import React from 'react';
import { Box, Checkbox, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../../styles/theme/foundation/colors';

const plural = (count, noun) => `${count} ${count === 1 ? noun : `${noun.replace(/y$/, 'ie') }s`}`;

const CloneOptionsStep = ({
  copyRequirementStatuses,
  setCopyRequirementStatuses,
  selectedPolicyCount,
  selectedDocumentCount,
  selectedRecordCount
}) => (
  <Box className="CloneOptionsStep">
    <HStack justifyContent="space-between" mb={4}>
      <Text textStyle="displayXxs">Options</Text>
    </HStack>

    <Box
      borderRadius="10px"
      boxShadow="sharp4"
      layerStyle="panel"
      mb={6}
      px={4}
      py={3}
    >
      <Text color={colors.greyScale['700']} textStyle="bodySm500">Ready to copy</Text>
      <Text color={colors.greyScale['700']} textStyle="bodySm">
        {`${plural(selectedPolicyCount, 'policy')} and ${plural(selectedDocumentCount, 'document')} to ${plural(selectedRecordCount, 'record')}`}
      </Text>
    </Box>

    <Checkbox
      alignItems="flex-start"
      data-cy="clone-copy-requirement-statuses"
      isChecked={copyRequirementStatuses}
      onChange={e => setCopyRequirementStatuses(e.target.checked)}
    >
      <Text textStyle="bodyMd500">Copy requirement statuses</Text>
      <Text color={colors.greyScale['700']} textStyle="bodySm">
        Apply this record&apos;s policy and document requirement statuses to each selected record.
        Only requirements still marked Not Received on the target record are changed.
      </Text>
    </Checkbox>
  </Box>
);

CloneOptionsStep.propTypes = {
  copyRequirementStatuses: PropTypes.bool.isRequired,
  setCopyRequirementStatuses: PropTypes.func.isRequired,
  selectedPolicyCount: PropTypes.number.isRequired,
  selectedDocumentCount: PropTypes.number.isRequired,
  selectedRecordCount: PropTypes.number.isRequired
};

export default CloneOptionsStep;
